import type { AdminPendingActionsVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrievePendingActions = createApiThunk<AdminPendingActionsVM, void>(
  "admin/adminRetrievePendingActions",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.hasPendingActions();
  },
);
